<template>
  <v-textarea
    auto-grow
    class="hiddenOutline border-15"
    :value="value"
    :placeholder="placeholder"
    :label="label"
    :outlined="outlined"
    :autofocus="autofocus"
    dense
    clearable
    clear-icon="mdi-close"
    :rules="rules"
    :hide-details="hideDetails"
    @input="$emit('input', $event)"
    :disabled="disabled"
    :rows="rows"
    :row-height="rowHeight"
    :filled="filled"
    :counter="counter"
  >
    <template v-slot:append>
      <slot />
    </template>
  </v-textarea>
</template>

<script>

export default {
  name: "CustomTextArea",
  props: {
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: Number,
      default: 1000,
    },
    rows: {
      type: Number,
      default: 6,
    },
    rowHeight: {
      type: Number,
      default: 30,
    },
    filled: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {

    };
  },
};
</script>

<style scoped>
</style>
